import {
  GET_PRODUCT_CATEGORY,
  UPDATE_PRODUCT_CATEGORY_SAGA,
  DELETE_PRODUCT_CATEGORY_SAGA
} from './actionsTypes';

const actions = {
  initData: () => ({ type: GET_PRODUCT_CATEGORY }),
  updateProductCategory: productCategory => {
    return (dispatch, getState) => {
      const productsCategory = getState().ProductsCategory.productsCategory;
      const index = productsCategory.map(inv => inv._id).indexOf(productCategory._id);

      if (index === -1) {
        productsCategory.unshift(productCategory);
      } else {
        productsCategory[index] = productCategory;
      }

      dispatch({
        type: UPDATE_PRODUCT_CATEGORY_SAGA,
        productsCategory,
        productCategory,
      });
    };
  },
  deleteProductCategory: id => {
    return (dispatch, getState) => {
      const productsCategory = getState().ProductsCategory.productsCategory;
      const newProductsCategory = [];
      productsCategory.forEach(productCategory => {
        if (productCategory._id !== id) {
          newProductsCategory.push(productCategory);
        }
      });
      dispatch({
        type: DELETE_PRODUCT_CATEGORY_SAGA,
        productsCategory: newProductsCategory,
        productCategory: id,
      });
    };
  },
};

export default actions;